import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

export const parallaxAnimation = (className: string, yOffset: string) => {
  return gsap.to(className, {
    y: yOffset, // Adjust the parallax effect as needed
    opacity: 1,
    duration: 1,
    ease: "power2.out",
    scrollTrigger: {
      trigger: ".overlay-div",
      start: "top 80%",
      end: "bottom top",
      scrub: true,
      markers: false,
    },
  });
};

gsap.registerPlugin(ScrollTrigger);

export const initFadeInAnimation = (className: string) => {
  const fadeElements = document.querySelectorAll(className);
  fadeElements.forEach((element) => {
    if ((element as HTMLElement).dataset.gsapFadeInInit === "true") return;
    (element as HTMLElement).dataset.gsapFadeInInit = "true";
    const rect = (element as HTMLElement).getBoundingClientRect();
    const isInView = rect.top < window.innerHeight && rect.bottom > 0;

    if (isInView) {
      gsap.from(element, { opacity: 0, y: 24, duration: 1 });
      return;
    }

    gsap.from(element, {
      opacity: 0,
      y: 24,
      duration: 1,
      scrollTrigger: {
        trigger: element,
        start: "top 80%",
        end: "bottom 20%",
        toggleActions: "play none none none",
        once: true,
      },
    });
  });
};

export const initFadeOutAnimation = (className: string) => {
  console.log("🚀 ~ initFadeOutAnimation ~ className:", className);
  const fadeOutElements = document.querySelectorAll(className);
  console.log("🚀 ~ initFadeOutAnimation ~ fadeOutElements:", fadeOutElements);

  fadeOutElements.forEach((element) => {
    gsap.to(element, {
      opacity: 0, // Fade out to zero
      duration: 2, // 2 seconds fade-out duration
      delay: 1, // Start fading out after 5 seconds
      ease: "power2.out", // Smooth easing effect
      onComplete: () => {
        gsap.set(element, { display: "none" }); // Hide the element after fading out
      },
    });
  });
};
